import Footer from 'components/Footer'
import Header from 'components/Header'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'layouts/FinanceLayout/main-view-layout.module.scss'
import WithDrawer from 'components/UI/withDrawer'
import Nav from 'components/Nav'
import { useSelector } from 'react-redux'
import financeNavigationConfig from 'constants/finance-navigation'
import WalletsList from 'modules/Finance/Wallets/subcomponents/WalletsList'

const FinanceLayout = ({
  children = null,
  noDrawer = false,
  drawerChildren = null,
}) => {
  const { user = {} } = useSelector(({ app }) => app)
  const config = financeNavigationConfig({ user })

  return (
    <>
      <div id={'drawer-root'} className={styles['drawer-root']} />
      <div className="main-wrapper">
        <Header />
        {!noDrawer ? (
          <WithDrawer
            extraNavigation={<WalletsList />}
            drawerChildren={
              drawerChildren ?? (config.length > 0 && <Nav items={config} />)
            }
          >
            {children}
          </WithDrawer>
        ) : (
          children
        )}
      </div>
      <Footer />
    </>
  )
}

FinanceLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  drawerChildren: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  noDrawer: PropTypes.bool,
}

export default FinanceLayout
